import FilterIndicator from 'Components/Generic/Misc/FilterIndicator';
import { SITE_PAGES } from 'Config';
import { useGlobalState } from 'Data/context/GlobalState';
import RequestData from 'Data/RequestData';
import OrderTable from './OrderTable';
import RequestLanding from './RequestLanding';

const AllOrdersListView = () => {
  const [globalState] = useGlobalState();
  let breadcrumb = [SITE_PAGES.ALL_ORDERS];

  let title = (
    <span>
      All Orders <FilterIndicator />
    </span>
  );

  return (
    <RequestLanding breadcrumbs={breadcrumb}>
      <OrderTable
        title={title}
        getRequestListFunction={RequestData.getRequestListFunction(
          globalState.fiscalYear,
        )}
        getExportRequestListFunction={RequestData.getExportRequestsFunc(
          globalState.fiscalYear,
        )}
        includeStatusColumn
      />
    </RequestLanding>
  );
};

export default AllOrdersListView;
